// sagas.js
import { takeLatest, put, call } from "redux-saga/effects";
import * as types from "../../actionTypes";
import AxiosInstance from "../../../services/AxiosInstance";
import { fetchCitiesSuccess,fetchCitiesFailure } from "./actions";

function* fetchCities(action) {
  try {
    
    // Call your API function here with action.payload.keyword
    const response = yield call(() =>
      AxiosInstance().post("/fetch_cities", action.payload)
    );
    if(response.data.status){

      yield put(fetchCitiesSuccess(response.data));
    }else{
      yield put(fetchCitiesFailure(response.data));
    }
  } catch (error) {
    // Dispatch failure action with the error
    yield put(fetchCitiesFailure({status:false,message:error.message}));
  }
}

// Watch for the latest FETCH_LOCATIONS_REQUEST action and call the saga
function* fetchCitiesSaga() {
  yield takeLatest(types.FETCH_CITIES_REQUEST, fetchCities);
}

export default fetchCitiesSaga;
